import axios from "axios";
import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import Select from "react-select";
import { countries } from "../../../data/options";

function EditInfo1({ profileInit, setProfileInit, isOpen, setIsOpen, onUpdateSuccess }) {
  const overlayClass = isOpen
    ? "fixed inset-0 bg-gray-500 opacity-75 z-50"
    : "hidden";
  const modalClass = isOpen
    ? "fixed inset-0 flex items-center justify-center z-50"
    : "hidden";
  const formClass = "border-2 border-x-gray-500 p-1 rounded-md";
  const [loading, setLoading] = useState(false);
  const [agents, setAgents] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    id: profileInit.id,
    firstName: profileInit.firstName,
    lastName: profileInit.lastName,
    DOB: profileInit.DOB,
    nationality: profileInit.nationality,
    mobile: profileInit.mobile,
    agentId: profileInit.agentId,
    status: profileInit.status,
    email: profileInit.email,
    bloodGroup: profileInit?.Health?.bloodGroup || '',
  });

  // Fetch agents on mount
  useEffect(() => {
    axios
      .get(`${apiUrl}/agent`, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then((res) => {
        setAgents(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.log("Failed to fetch agents:", err);
      });
  }, []);

  // Update formData when profileInit changes
  useEffect(() => {
    setFormData({
      id: profileInit.id,
      firstName: profileInit.firstName,
      lastName: profileInit.lastName,
      DOB: profileInit.DOB,
      nationality: profileInit.nationality,
      mobile: profileInit.mobile,
      agentId: profileInit.agentId,
      status: profileInit.status,
      email: profileInit.email,
      bloodGroup: profileInit?.Health?.bloodGroup || '',
    });
  }, [profileInit]);

  const updateProfile = async () => {
    setLoading(true);
    console.log('Sending form data:', formData);
    
    const dataToSend = {
      id: formData.id,
      firstName: formData.firstName,
      lastName: formData.lastName,
      DOB: formData.DOB,
      nationality: formData.nationality,
      mobile: formData.mobile,
      email: formData.email,
      agentId: formData.agentId,
      status: formData.status,
      bloodGroup: formData.bloodGroup,
    };
    
    console.log('Data being sent to API:', dataToSend);
    
    axios
      .put(`${apiUrl}/employee/updatePersonalInfo`, dataToSend, {
        headers: {
          loginToken: localStorage.getItem("loginToken"),
        },
      })
      .then(async (result) => {
        setLoading(false);
        console.log('Update response:', result);
        if (result.data.message || result.status === 200) {
          swal({
            icon: "success",
            title: "Update",
            text: "Info Updated Successfully!",
            buttons: false,
            timer: "2000",
          });

          setIsOpen(false);
          
          // Call the callback to refresh data from server
          if (onUpdateSuccess) {
            await onUpdateSuccess();
          }
        } else {
          console.log('Update failed - no message in response:', result);

          swal({
            icon: "error",
            title: "Oops!",
            text: result.data.error || "Update failed",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error('API Error:', err);
        if (err.response) {
          console.error('Error response data:', err.response?.data);
          swal({
            title: "Error",
            icon: "error",
            text: err.response?.data?.error || "Failed to update",
          });
        } else {
          console.error('Network error:', err);
          swal({
            title: "Error",
            icon: "error",
            text: "Network error occurred",
          });
        }
      });
  };

  return (
    <div className="text-black">
      <div className={overlayClass} onClick={() => setIsOpen(false)}></div>

      <div className={modalClass}>
        <div className="bg-white rounded-xl shadow-lg overflow-hidden w-full max-w-2xl mx-auto">
          <div className="p-4 sm:p-6 relative">
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none"
              onClick={() => setIsOpen(false)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">
              Update Personal Info
            </h2>
            <hr className="mb-6 border-gray-300" />

            <form className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                <input type="text" value={formData.firstName} onChange={e => setFormData({ ...formData, firstName: e.target.value })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" required />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                <input type="text" value={formData.lastName} onChange={e => setFormData({ ...formData, lastName: e.target.value })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" required />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">DOB</label>
                <input type="text" value={formData.DOB} onChange={e => setFormData({ ...formData, DOB: e.target.value })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" required />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nationality</label>
                <Select
                  name="nationality"
                  onChange={(option) => setFormData({ ...formData, nationality: option ? option.value : '' })}
                  options={countries}
                  value={formData.nationality ? { value: formData.nationality, label: formData.nationality } : null}
                  classNamePrefix="select"
                  placeholder="Select Nationality"
                  isClearable
                  isSearchable
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                      boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                      '&:hover': {
                        borderColor: '#3b82f6',
                      },
                    }),
                  }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input type="email" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" required />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mobile</label>
                <input type="text" value={formData.mobile} onChange={e => setFormData({ ...formData, mobile: e.target.value })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" required />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Agent Name</label>
                <Select
                  name="agentId"
                  onChange={(option) => setFormData({ ...formData, agentId: option ? option.value : null })}
                  options={agents.map(agent => ({ value: agent.id, label: agent.name }))}
                  value={formData.agentId ? { value: formData.agentId, label: agents.find(a => a.id === formData.agentId)?.name || 'Select Agent' } : null}
                  classNamePrefix="select"
                  placeholder="Select Agent"
                  isClearable
                  isSearchable
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                      boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
                      '&:hover': {
                        borderColor: '#3b82f6',
                      },
                    }),
                  }}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                <select value={formData.status} onChange={e => setFormData({ ...formData, status: e.target.value })} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" required>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
              <div className="md:col-span-2">
                <button
                  type="button"
                  onClick={updateProfile}
                  className="w-full mt-4 py-2 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg transition duration-150 ease-in-out flex items-center justify-center"
                  disabled={loading}
                >
                  {loading ? (
                    <svg
                      className="animate-spin h-5 w-5 mr-3 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path d="M4 12a8 8 0 018-8v8H4z" fill="currentColor"></path>
                    </svg>
                  ) : null}
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default EditInfo1;
